import React from "react";
import style from "./style.module.scss"

const SideModal = ({ children, close }) => {
    const onClose  = (e) => {
        e.preventDefault()
        if (e.target === e.currentTarget) {
            close()

          }
    }
    return (
        <div className={style.sideModal} onClick={onClose} >
            <div className={style.modal} >        
            {children}
            </div>
        </div>
    );
}

export default SideModal;